export default __webpack_public_path__ + "static/benefits-c82516f0886be8e988724cc23958140d.png";